import {
  Button,
  Modal,
} from "@twinkltech/curriculum-architect-component-library";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { COMMON_NS } from "@/i18n/common/common.i18n";
import { paths } from "@/paths";

import { SIGNED_OUT_MODAL_NS } from "./SignedOutModal.i18n";

export const SignedOutModal = () => {
  const { t } = useTranslation(SIGNED_OUT_MODAL_NS);
  return (
    <Modal open hasCloseButton={false} width="sm" onClose={() => {}}>
      <Modal.Header>
        <Modal.Title>{t("signed_out")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{t("signed_out_message")}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          as={Link}
          rel="noreferrer noopener"
          to={paths.external.TWINKL_LOGIN_URL()}
          variant="primary"
        >
          {t("actions.login", { ns: COMMON_NS })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
